// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/HoverView/styles.scss
// module id = 807
// module chunks = 0